import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../routes/routes';

/**
 * The Stock Take screen is retired [SSD-7447]. A shelf is counted in Inventory's Stock Audit: scan its label and press
 * Count this shelf (the phone camera reads the label too), and each count goes into the stock as it is saved. Past
 * Audit Logs lists every round and closes an open one left behind. The old address lands on Inventory so a bookmark
 * still goes somewhere.
 */
export default function FulfillmentStockTakePage() {
  return <Navigate to={ROUTES.fulfillment.inventory} replace />;
}
